export function MaxProcessingIcon({ active }: any) {
  const color: string = active ? "#006AB3" : "#000000";
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 3.75H6.25V5H5V3.75ZM7.5 3.75H8.75V5H7.5V3.75ZM12.5 3.75H13.75V5H12.5V3.75ZM15 3.75H16.25V5H15V3.75ZM17.5 3.75H18.75V5H17.5V3.75Z"
        fill={color}
      />
      <path
        d="M17.4931 17.5L17.4762 17.3981C16.5688 11.9213 15.0413 5.68062 11.25 5.05562V3.75H10V5.05312C6.1975 5.66437 4.66687 11.9144 3.75875 17.3981L3.74187 17.5H2.5V5H3.75V3.75H2.5V1.25H1.25V17.5C1.25 17.8315 1.3817 18.1495 1.61612 18.3839C1.85054 18.6183 2.16848 18.75 2.5 18.75H18.75V17.5H17.4931ZM5.00938 17.5C6.27437 9.9325 8.10938 6.25 10.6175 6.25C13.1256 6.25 14.9606 9.9325 16.225 17.5H5.00938Z"
        fill={color}
      />
    </svg>
  );
}
